import { Builder } from "@builder.io/react";
import { BuilderElement } from "@builder.io/sdk";

import { BuilderAccordionV2 as BuilderAccordion } from "./BuilderAccordionV2";

const defaultDetail: BuilderElement = {
  "@type": "@builder.io/sdk:Element",
  layerName: "Accordion item detail",
  children: [
    {
      "@type": "@builder.io/sdk:Element",
      component: {
        name: "Typography",
        options: {
          textContent: "I am an accordion detail, hello!",
        },
      },
    },
  ],
};

export const registerBuilderAccordionV2 = () => {
  Builder.registerComponent(BuilderAccordion, {
    name: "AccordionV2",
    hideFromInsertMenu: true,
    // to make sure accordion is not wrapped in a div
    noWrap: true,
    canHaveChildren: true,
    inputs: [
      {
        name: "useComponentsForItems",
        type: "boolean",
        helperText: "Use components as items instead of text fields.",
        advanced: true,
        defaultValue: false,
        onChange: (options: Map<string, any>) => {
          if (options.get("useComponentsForItems") === true) {
            options.set("contents", []);
          } else {
            options.set("contentComponents", []);
          }
        },
      },
      {
        name: "contents",
        type: "list",
        subFields: [
          {
            name: "question",
            type: "string",
            localized: true,
          },
          {
            name: "answer",
            type: "richText",
            localized: true,
          },
        ],
        showIf: (options) => !options.get("useComponentsForItems"),
      },
      {
        name: "contentComponents",
        type: "list",
        broadcast: true,
        subFields: [
          {
            name: "question",
            type: "string",
            localized: true,
          },
          {
            name: "answer",
            type: "uiBlocks",
            defaultValue: [defaultDetail],
          },
        ],
        showIf: (options) => options.get("useComponentsForItems"),
      },
    ],
  });
};
